
<div mat-dialog-title>Import Extra Cash Settings<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
<mat-dialog-content>
  @if (hasFile && !isValidFile) {
    <mat-card class="error block">
      <mat-card-title class="error">{{invalidFileErrorHeader}}</mat-card-title>
      <mat-card-subtitle>{{invalidFileErrorMessage}}</mat-card-subtitle>
    </mat-card>
  }
  @if (errorMessage) {
    <mat-card class="error block">
      <mat-card-title class="error">An error occurred.</mat-card-title>
      <mat-card-subtitle>{{errorMessage}}</mat-card-subtitle>
    </mat-card>
  }
  <div>Import a .csv file of the account numbers and their extra cash amounts into this rebalance. (The accounts must already exist in iRebal portfolios.)</div>
  <div>
    <table class="import" width="100%">
      <tr>
        <th align="left" style="vertical-align: top;"><label>File name</label></th>
        <td>
          <div class="bottomPaddingElementDialog">
            <irb-file-selector (change)="onFileChange($event)"></irb-file-selector>
            <div>File type must be .csv</div>
          </div>
        </td>
      </tr>
      <tr>
        <th align="left" style="vertical-align: top;"><label>Instructions</label></th>
        <td><div class="block">
          Your imported file must be in the .csv (Comma Separated Values) format, and adhere to iRebal's .csv conventions below:
        AccountNumber,ExtraCashDollarAmount</div></td>
      </tr>
      <tr>
        <th align="left" style="vertical-align: top;"><label>Template</label></th>
        <td>
          <div>Use our .csv template to prepare your file.<br/>
            <a download href="/assets/template/ExtraCashCSV.csv">Download template: ExtraCashCSV.csv</a></div>
          </td>
        </tr>
      </table>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
    <button id="continueButton" (click)="submitFile()" [disabled]="!(hasFile && isValidFile)" class="btn-medium-primary">Continue</button>
  </mat-dialog-actions>
